import Vue from 'vue'
import Vuex, { ModuleTree } from 'vuex'
import VuexPersist from 'vuex-persist'
import { meals, MealState } from './meals';
import { auth, AuthState } from './auth';
import { counter, CounterState } from './counter';

Vue.use(Vuex);

export interface IState {
  counter: CounterState;
  meals: MealState;
  auth: AuthState;
}

const vuexPersist = new VuexPersist<IState>({
  key: 'MealCounter',
  storage: window.localStorage,
  modules: ['meals','auth','counter']
});

const store = new Vuex.Store<IState>({
  modules: {
    counter,
    meals,
    auth
  } as ModuleTree<IState>,
  plugins: [vuexPersist.plugin]
});

export default store
export * from './types';
export * from './auth';
export * from './meals';
export * from './counter';
